// ------------------------------------------
// 「parallax-item」クラスの要素がスクロールに対して周囲よりわずかに遅れて見える
// data-parallax-shift で縦方向の移動幅(px・セクション通過中の目安)を変更（既定 40）
// ------------------------------------------
class ParallaxItem {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const selector = '.' + this.el;
    gsap.utils.toArray(selector).forEach((node) => {
      const shift =
        node.dataset.parallaxShift != null
          ? parseFloat(node.dataset.parallaxShift)
          : 40;
      const trigger =
        node.closest('section') ||
        node.closest('[data-parallax-root]') ||
        node.parentElement ||
        document.documentElement;

      gsap.fromTo(
        node,
        { y: shift * 0.5 },
        {
          y: -shift * 0.5,
          ease: 'none',
          scrollTrigger: {
            trigger,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            invalidateOnRefresh: true,
          },
        }
      );
    });

    $(window).on('load.parallaxItem', () => {
      ScrollTrigger.refresh();
    });
  }
}
